import axios from "axios";
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _getLang = "/Language";
const getLang = axios.create({
  baseURL: checkEnvironment(_basic, _getLang)
});


export const getLangOption = async () => {
  return await getLang.get("/GetLanguage");
};
